import * as React from "react";
import QuestionLabel from "./QuestionLabel";
import QuestionError from "./QuestionError";
import StarRating from "../../StarRating";

interface StarRatingQuestionProps {
  question: any;
  error: string;
  onChange: any;
  answer: number;
}

class StarRatingQuestion extends React.Component<StarRatingQuestionProps, {}> {
  onChange = (value: number) => {
    this.props.onChange(this.props.question, value);
  };

  render() {
    return (
      <div>
        <QuestionLabel question={this.props.question} />
        <StarRating
          questionId={this.props.question.QuestionID}
          onChange={this.onChange}
          value={this.props.answer}
        />
        <QuestionError
          questionId={this.props.question.QuestionID}
          error={this.props.error}
        />
      </div>
    );
  }
}

export default StarRatingQuestion;
